const jobsCalendar = {
  view: 'Visualizar',
  calendarView: {
    monthly: 'Mensal',
    weekly: 'Semanal',
  },

  modalRemoveConfirm: {
    header: 'Aviso!',
    bodySingle: 'Você tem certeza de que deseja excluir esta reserva?',
    bodyMultiple: 'Você tem certeza que deseja excluir estas reservas?',
    confirmBtn: 'Remover',
  },

  calendarTable: {
    actions: {
      delete: 'Remover'
    },
    cells: {
      dayOff: 'Dia de folga',
    },
    headers: {
      name: 'Nome',
      monday: 'Segunda-feira {{day}}',
      tuesday: 'Terça-feira {{day}}',
      wednesday: 'Quarta-feira {{day}}',
      thursday: 'Quinta-feira {{day}}',
      friday: 'Sexta-feira {{day}}',
      saturday: 'Sábado {{day}}',
      sunday: 'Domingo {{day}}',
    },
  },

  filters: {
    students: 'Alunos',
    caregivers: 'Cuidadores',
  }, 

  shiftsFilter:{
    all:'Todos os Passageiros',
    withShift: 'Passageiros com Turnos',
    withoutShifts: 'Passageiros sem turnos',
  },
};

export default jobsCalendar;